import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Externally_Service_Form from "./externally_Service_Form/Externally_Service_Form";
import Externally_Service_table from "./externally_Service_table/Externally_Service_table";
import {
  Create,
  GetAll,
} from "../../../../../../../src/features/admin/quality_management/resource_requirement/externaldetails/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../utils/fixIDS";

function Externally_Service() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const externaldetails = useSelector((state) => state.externally_provided);
 
  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: externaldetails.per_page,
      }),
    );
  };

  const permissions = useSelector((state) => state.auth.permissions);
                          
  const haveReadPermission = permissions?.includes(FixIDS.externally_provided.List);
  const haveAddPermission = permissions?.includes(FixIDS.externally_provided.Add);

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage]);

  return (
    <>
      <section className="Imperiality Quality_Policy ScopeOfTheLaboratory">
        <div className="back_div">
          <Common_Back_Btn backText="Externally Service" />
        </div>

        <div className="imperiality_Form_div">
          { haveAddPermission && <Externally_Service_Form />}
        </div>

        <div className="imperiality_table_div">
          { haveReadPermission && <Externally_Service_table
            data={externaldetails}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            fetchCustomers={fetchCustomers}
          /> }
        </div>
      </section>
    </>
  );
}

export default Externally_Service;
